import { Button, Modal } from 'react-bootstrap';

interface FillQuestionnaireDialogProps {
  show: boolean;
  onHide: (result: boolean) => void;
}

export const FillQuestionnaireDialog = ({ show, onHide }: FillQuestionnaireDialogProps) => {
  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Fill out the Questionnaire</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Prior to accepting the connection request please fill out the short questionnaire. It would
        take only a few minutes.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={() => onHide(false)}>
          Complete Later
        </Button>
        <Button variant="primary" onClick={() => onHide(true)}>
          Fill Out Questionnaire
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
